import { Types } from '../../../constants';
import { IsHelper } from '../IsHelper';
export class IsTransactionHelper extends IsHelper {
    constructor() {
        super(...arguments);
        this.type = Types.Transaction;
    }
}

//# sourceMappingURL=IsTransactionHelper.js.map
